import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../UI/Button/Button';

const blogItem = props => (
    <div className="blogItem"> 
        <div className="mx-4 mb-md-5 d-flex flex-column align-items-center align-items-md-start">
            <div className="wrap-img">
                <picture>
                    {props.srcWebp && <source srcSet={props.srcWebp} type="image/webp" />}
                    <source src={props.src} type="image/png" />
                    <img src={props.src} alt={props.alt} className="mb-4" />
                </picture>
            </div>
            <div className="justify-content-center mt-2 mt-lg-5 px-2">
                <h2 className="p fw-600">{props.title}</h2>
            </div>
            <Link to={props.link} target="_blank">
                <Button 
                    btnClasses={'wh-35 h5 fw-600 text-uppercase my-4 ml-0'}
                > + </Button>
            </Link>
        </div>
    </div>
);

export default blogItem;